import { ReactNode } from 'react'

import AmexSVG from 'app/assets/icons/listing/amex.svg'
import ApplePay from 'app/assets/icons/listing/apple-pay.svg'
import GooglePay from 'app/assets/icons/listing/google-pay.svg'
import MastercardSVG from 'app/assets/icons/listing/mastercard.svg'
import PayPalSVG from 'app/assets/icons/listing/paypal.svg'
import UnionPaySVG from 'app/assets/icons/listing/union-pay-card.svg'
import VisaSVG from 'app/assets/icons/listing/visa.svg'
import { PAYMENT_CARDS_STATUS } from 'app/utils/constants/status.constants'

export const getCards = (
  paymentMethod: CheckoutPayment
): { icon: ReactNode }[] => {
  const isBoth = paymentMethod === PAYMENT_CARDS_STATUS.both
  const isStripe = paymentMethod === PAYMENT_CARDS_STATUS.stripe

  const showBothOrPaypal = isBoth || !isStripe
  const showBothOrStripe = isBoth || isStripe

  const cards = [
    showBothOrPaypal && { icon: <PayPalSVG /> },
    showBothOrStripe && { icon: <VisaSVG /> },
    showBothOrStripe && { icon: <MastercardSVG /> },
    showBothOrStripe && { icon: <AmexSVG /> },
    showBothOrStripe && { icon: <UnionPaySVG /> },
    showBothOrStripe && { icon: <GooglePay /> },
    showBothOrStripe && { icon: <ApplePay /> }
  ].filter(Boolean)

  return cards as { icon: ReactNode }[]
}
